import React from "react";

import styled from "styled-components";
import { space, SpaceProps, layout, LayoutProps, display } from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps {
  children?: React.ReactNode;
}


const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const OwnersSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="owners-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 20 14"
        data-testid="owners-svg"
      >
        <defs>
          <path
            id="owners"
            d="M10 10c1.934 0 3.5-1.566 3.5-3.5S11.934 3 10 3 6.5 4.566 6.5 6.5 8.066 10 10 10zM3 9c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm14 0c1.103 0 2-.897 2-2s-.897-2-2-2-2 .897-2 2 .897 2 2 2zm2 5c.553 0 1-.447 1-1v-1c0-1.103-.897-2-2-2h-2c-.55 0-1.047.222-1.41.581 1.26.69 2.154 1.938 2.347 3.419H19zM3.06 14c.196-1.481 1.09-2.728 2.35-3.419C5.046 10.221 4.55 10 4 10H2c-1.103 0-2 .897-2 2v1c0 .553.447 1 1 1h2.06zm11.44 3c.828 0 1.5-.672 1.5-1.5v-.9c0-1.988-1.613-3.6-3.6-3.6h-.26c-.65.313-1.371.5-2.14.5-.769 0-1.488-.187-2.14-.5H7.6C5.612 11 4 12.612 4 14.6v.9c0 .828.672 1.5 1.5 1.5h9z"
          />
        </defs>
        <g fill="none" transform="translate(0 -3)">
          <use fill="#0B0B0B" href="#owners" />
          <use fill="#070B16" href="#owners" />
        </g>
      </svg>
    </StyledContainer>
  );
};

export default OwnersSVG;
